/** Two services on one carrier can't share a name; the database compares them trimmed and case-insensitively. */
export function serviceNamesProblem(serviceNames) {
    const seen = new Set();
    for (const serviceName of serviceNames) {
        const key = serviceName.trim().toLowerCase();
        if (seen.has(key))
            return 'A service is listed twice.';
        seen.add(key);
    }
    return null;
}
//# sourceMappingURL=service-names-problem.js.map